'use strict';
var __importDefault = this && this.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { 'default': mod };
};
Object.defineProperty(exports, '__esModule', { value: true });
const EntityTypes_1 = __importDefault(require('./EntityTypes'));
exports.findAllEntities = contentState => {
    const blockMap = contentState.getBlockMap();
    const entities = [];
    blockMap.forEach(contentBlock => {
        if (contentBlock) {
            contentBlock.findEntityRanges(character => {
                const entityKey = character.getEntity();
                if (entityKey !== null) {
                    const data = contentState.getEntity(entityKey).getData();
                    if (EntityTypes_1.default[data.type]) {
                        entities.push(data);
                        return true;
                    }
                }
                return false;
            }, () => {
            });
        }
    });
    return entities;
};    //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmluZEFsbEVudGl0aWVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2V2YWx1YXRvci9maW5kQWxsRW50aXRpZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFDQSx3RUFBZ0Q7QUFHbkMsUUFBQSxlQUFlLEdBQUcsQ0FBQyxZQUEwQixFQUFFLEVBQUU7SUFDNUQsTUFBTSxRQUFRLEdBQUcsWUFBWSxDQUFDLFdBQVcsRUFBRSxDQUFDO0lBQzVDLE1BQU0sUUFBUSxHQUFzQixFQUFFLENBQUM7SUFDdkMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxZQUFZLENBQUMsRUFBRTtRQUM5QixJQUFJLFlBQVksRUFBRTtZQUNoQixZQUFZLENBQUMsZ0JBQWdCLENBQzNCLFNBQVMsQ0FBQyxFQUFFO2dCQUNWLE1BQU0sU0FBUyxHQUFHLFNBQVMsQ0FBQyxTQUFTLEVBQUUsQ0FBQztnQkFDeEMsSUFBSSxTQUFTLEtBQUssSUFBSSxFQUFFO29CQUN0QixNQUFNLElBQUksR0FBb0IsWUFBWTt5QkFDdkMsU0FBUyxDQUFDLFNBQVMsQ0FBQzt5QkFDcEIsT0FBTyxFQUFFLENBQUM7b0JBQ2IsSUFBSSxxQkFBVyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsRUFBRTt3QkFDMUIsUUFBUSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQzt3QkFDcEIsT0FBTyxJQUFJLENBQUM7cUJBQ2I7aUJBQ0Y7Z0JBQ0QsT0FBTyxLQUFLLENBQUM7WUFDZixDQUFDLEVBQ0QsR0FBRyxFQUFFLEdBQUUsQ0FBQyxDQUNULENBQUM7U0FDSDtJQUNILENBQUMsQ0FBQyxDQUFDO0lBQ0gsT0FBTyxRQUFRLENBQUM7QUFDbEIsQ0FBQyxDQUFDIn0=
